function debounce(fn, wait) {
    let t;
    return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
    };
}

function fetchConfig(type = 'json') {
    return {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
    };
}

class CartRemoveButton extends HTMLElement {
	constructor() {
		super();
		this.addEventListener('click', (event) => {
			event.preventDefault();
			const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
			cartItems.updateQuantity(this.dataset.index, 0, 'remove', event);
		});
	}
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
    constructor() {
        super();
	    
	    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

        this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
            .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

        this.debouncedOnChange = debounce((event) => {
            this.onChange(event);
        }, 300);

        this.addEventListener('change', this.debouncedOnChange.bind(this));

        // this.checkOldBundle();

        this.checkProducts(true);
        this.checkEmbossingAndGiftPackaging();
    }

    onChange(event) {
        this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event);
    }

    getSectionsToRender() {
        return [
            {
                id: 'main-cart-items',
                section: document.getElementById('main-cart-items').dataset.id,
                selector: '.js-contents',
            },
            {
                id: 'cart-icon-bubble',
                section: document.getElementById('cart-icon-bubble').dataset.id,
                selector: '.js-icon'
            },
            {
                id: 'main-cart-footer',
                section: document.getElementById('main-cart-footer').dataset.id,
                selector: '.js-contents-footer',
            }
        ];
    }

    updateQuantity(line, quantity, name, event) {
        this.enableLoading(line);

        if (event) var uniqId = event.target.dataset.uniqId;
        if (uniqId != undefined) {
	        var uniqIdBlocks = document.querySelectorAll('.quantity__input[data-uniq-id="' + uniqId + '"]');
	        uniqIdBlocks.forEach(block => { block.value = quantity; });
			
	        fetch('/cart.json')
		        .then(response => response.json())
		        .then(cartData => {
			        const linkedItems = cartData.items.filter(item =>
				        (item.properties && item.properties['_bundle_uniq_id'] == uniqId) ||
				        (item.properties && item.properties['_uniqId'] == uniqId)
			        );
					
			        if (linkedItems.length === 0) {
				        this.disableLoading(line);
				        return;
			        }
					
			        let primaryItem = linkedItems.find(item => item.key === cartData.items[line - 1]?.key) || linkedItems[0];
			        let secondaryItems = linkedItems.filter(item => item.key !== primaryItem.key);
					
			        const body = JSON.stringify({
				        line: line,
				        quantity: quantity,
				        sections: this.getSectionsToRender().map((section) => section.section),
				        sections_url: window.location.pathname
			        });
			        
			        fetch(theme.routes.cart_change_url, { ...fetchConfig(), ...{ body } })
				        .then((response) => response.json())
				        .then((parsedState) => {
					        if (parsedState.errors) {
						        const savedErrors = parsedState.errors;
						        this.updateLiveRegions(line, savedErrors);
						        const shopLimit = parseInt(this.dataset.cartLimit, 10);
						        let safeQuantity = quantity;
						        
						        uniqIdBlocks.forEach(block => {
							        const inventoryMaxAttr = block.getAttribute('data-max');
							        if (inventoryMaxAttr) {
								        const inventoryMax = parseInt(inventoryMaxAttr, 10);
								        safeQuantity = Math.min(inventoryMax, shopLimit);
								        block.value = safeQuantity;
							        } else {
								        block.value = primaryItem.quantity;
							        }
						        });
						        
						        let recoveryUpdates = {};
						        recoveryUpdates[primaryItem.key] = safeQuantity;
								
						        secondaryItems.forEach(item => {
							        recoveryUpdates[item.key] = safeQuantity;
						        });
						        
						        fetch(window.Shopify.routes.root + 'cart/update.js', {
							        method: 'POST',
							        headers: { 'Content-Type': 'application/json' },
							        body: JSON.stringify({
								        updates: recoveryUpdates,
								        sections: this.getSectionsToRender().map((section) => section.section),
								        sections_url: window.location.pathname
							        })
						        })
						        .then(res => res.json())
						        .then(finalState => {
							        this.checkProducts(false);
							        this.updateCartList(finalState, line, name);
							        this.checkEmbossingAndGiftPackaging();
							        this.updateLiveRegions(line, savedErrors);
						        })
						        .finally(() => {
							        this.disableLoading(line);
						        });
						        return;
					        }
							
					        let updates = {};
					        secondaryItems.forEach(item => {
						        updates[item.key] = quantity;
					        });
							
					        if (Object.keys(updates).length === 0) {
						        this.checkProducts(false);
						        this.updateCartList(parsedState, line, name);
						        this.checkEmbossingAndGiftPackaging();
						        this.disableLoading(line);
						        return;
					        }
					        
					        fetch(window.Shopify.routes.root + 'cart/update.js', {
						        method: 'POST',
						        headers: { 'Content-Type': 'application/json' },
						        body: JSON.stringify({
							        updates: updates,
							        sections: this.getSectionsToRender().map((section) => section.section),
							        sections_url: window.location.pathname
						        })
					        })
					        .then(res => res.json())
					        .then(finalState => {
						        this.checkProducts(false);
						        this.updateCartList(finalState, line, name);
						        this.checkEmbossingAndGiftPackaging();
					        })
					        .finally(() => {
						        this.disableLoading(line);
					        });
				        })
				        .catch(() => {
					        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
					        this.disableLoading(line);
				        });
		        });
        } else {
            const body = JSON.stringify({
                line,
                quantity,
                sections: this.getSectionsToRender().map((section) => section.section),
                sections_url: window.location.pathname
            });

            fetch(theme.routes.cart_change_url, {...fetchConfig(), ...{body}})
                .then((response) => {
                    return response.text();
                })
                .then((state) => {
                    const parsedState = JSON.parse(state);
                    this.checkProducts(false);
                    this.updateCartList(parsedState, line, name);
                    this.checkEmbossingAndGiftPackaging();
                })
	            .catch(() => {
	                this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
	                // document.getElementById('cart-errors').textContent = window.cartStrings.error;
	            })
	            .finally(() => {
		            this.disableLoading(line);
	            });
        }
    }
	
	updateLiveRegions(line, message) {
		const lineItemError =
			document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
		if (lineItemError) lineItemError.querySelector('.cart-item__error-text').textContent = message;
		
		this.lineItemStatusElement.setAttribute('aria-hidden', true);
		
		const cartStatus =
			document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
		cartStatus.setAttribute('aria-hidden', false);
		
		setTimeout(() => {
			cartStatus.setAttribute('aria-hidden', true);
		}, 1000);
	}

    getSectionInnerHTML(html, selector) {
        return new DOMParser()
            .parseFromString(html, 'text/html')
            .querySelector(selector).innerHTML;
    }

    enableLoading(line) {
	    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('drawer-cart-items');
	    mainCartItems.classList.add('cart__items--disabled');
	    
	    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
	    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);
	    
	    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));
		
        document.activeElement.blur();
        this.lineItemStatusElement.setAttribute('aria-hidden', false);
    }

    disableLoading(line) {
	    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('drawer-cart-items');
	    mainCartItems.classList.remove('cart__items--disabled');
	    
	    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
	    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);
	    
	    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
	    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    }

    updateCartList(parsedState, line, name) {
	    if (parsedState.errors) {
		    const quantityElement =
			    document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
		    
		    const previousValue = quantityElement.getAttribute('value');
		    const shopLimit = parseInt(this.dataset.cartLimit, 10);
		    const inventoryMaxAttr = quantityElement.getAttribute('data-max');
		    
		    if (inventoryMaxAttr) {
			    const inventoryMax = parseInt(inventoryMaxAttr, 10);
			    quantityElement.value = Math.min(inventoryMax, shopLimit);
		    } else {
			    quantityElement.value = previousValue;
		    }
		    this.updateLiveRegions(line, parsedState.errors);
		    return;
	    }
		
        this.classList.toggle('is-empty', parsedState.item_count === 0);
		const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
	    if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
            const elementToReplace =
                document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

            elementToReplace.innerHTML =
                this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));
		
	    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: parsedState } }));
	    theme.initComponents($(cartDrawerWrapper));

        const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
		if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
	        cartDrawerWrapper
		        ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
		        : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
	        trapFocus(cartDrawerWrapper.querySelector('.cart-drawer__warnings'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
	        trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }
        // this.disableLoading(line);
    }

    // checkFreeGift() {
    //     if (theme.giftsSettings.freeGiftEnable) {
    //         fetch('/cart.json').then(response => response.json())
    //             .then(cart => {
    //                 let totalPrice = cart.total_price,
    //                     limitPrice1 = theme.giftsSettings.freeGiftLimit,
    //                     limitPrice2 = theme.giftsSettings.freeGiftLimit2,
    //                     limitPrice3 = theme.giftsSettings.freeGiftLimit3,
    //                     addFreeGiftCheck = false,
    //                     memberCustomer = false,
    //                     freeGiftMainProduct = false,
    //                     freeGiftProductsList = theme.giftsSettings.freeGiftProductsList.trim().split(',');
    //
    //                 let giftLimit1 = theme.giftsSettings.freeGiftLimitVariant != '' ? theme.giftsSettings.freeGiftLimitVariant : theme.giftsSettings.freeGiftLimitProduct,
    //                     giftLimit2 = theme.giftsSettings.freeGiftLimitVariant2 != '' ? theme.giftsSettings.freeGiftLimitVariant2 : theme.giftsSettings.freeGiftLimitProduct2,
    //                     giftLimit3 = theme.giftsSettings.freeGiftLimitVariant3 != '' ? theme.giftsSettings.freeGiftLimitVariant3 : theme.giftsSettings.freeGiftLimitProduct3,
    //                     giftSP = theme.giftsSettings.freeGiftSPVariant != '' ? theme.giftsSettings.freeGiftSPVariant : theme.giftsSettings.freeGiftSPProduct;
    //
    //                 if (theme.giftsSettings.freeGiftOnlyForMembers) {
    //                     memberCustomer = theme.memberCustomer ? true : false;
    //                 } else {
    //                     memberCustomer = true;
    //                 }
    //
    //                 var giftInCart = false;
    //                 cart.items.forEach((cartItem,i) => {
    //                     if (cartItem.properties['_product_type'] == 'free gift') {
    //                         giftInCart = true;
    //                     }
    //                     freeGiftProductsList.forEach(item => {
    //                         var item_trim = item.trim();
    //                         if (item_trim == cartItem.handle) {
    //                             freeGiftMainProduct = true;
    //                         }
    //                     })
    //                 })
    //
    //                 if (theme.giftsSettings.freeGiftType == 'cart_limit') {
    //                     if (memberCustomer) {
    //                         if (totalPrice >= limitPrice1 && totalPrice < limitPrice2 && giftLimit1 != null) {
    //                             this.updateFreeGiftLimitCart(cart, giftLimit1);
    //                         } else if (totalPrice >= limitPrice2 && totalPrice < limitPrice3 && giftLimit2 != null) {
    //                             this.updateFreeGiftLimitCart(cart, giftLimit2);
    //                         } else if (totalPrice >= limitPrice3 && giftLimit3 != null) {
    //                             this.updateFreeGiftLimitCart(cart, giftLimit3);
    //                         } else if (giftInCart) {
    //                             var cartQntArray = [];
    //
    //                             for (var i = 0; i < cart.items.length; i++) {
    //                                 if (cart.items[i].properties['_product_type'] == 'free gift') {
    //                                     cartQntArray.push(0);
    //                                 } else {
    //                                     cartQntArray.push(cart.items[i].quantity);
    //                                 }
    //                             }
    //
    //                             var formData = {
    //                                 updates: cartQntArray,
    //                                 sections: this.getSectionsToRender().map((section) => section.section),
    //                                 sections_url: window.location.pathname
    //                             };
    //
    //                             fetch(window.Shopify.routes.root + 'cart/update.js', {
    //                                 method: 'POST',
    //                                 headers: {
    //                                     'Content-Type': 'application/json'
    //                                 },
    //                                 body: JSON.stringify(formData)
    //                             })
    //                                 .then((response) => {
    //                                     return response.text();
    //                                 })
    //                                 .then((state) => {
    //                                     const parsedState = JSON.parse(state);
    //                                     this.classList.toggle('is-empty', parsedState.item_count === 0);
    //                                     const cartFooter = document.getElementById('main-cart-footer');
    //
    //                                     if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
    //
    //                                     this.getSectionsToRender().forEach((section => {
    //                                         const elementToReplace =
    //                                             document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
    //
    //                                         elementToReplace.innerHTML =
    //                                             this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
    //                                     }));
    //                                 });
    //
    //                         }
    //                     }
    //
    //
    //                 } else {
    //                     if (memberCustomer && giftSP !== undefined && freeGiftMainProduct) {
    //                         if (!giftInCart && cart.item_count > 0) {
    //                             this.addFreeGift(giftSP);
    //
    //                         } else if (giftInCart && cart.item_count === 1) {
    //                             this.removeFreeGiftSP(giftSP);
    //                         }
    //                     } else {
    //                         if (giftInCart) {
    //                             this.removeFreeGiftSP(giftSP);
    //                         }
    //                     }
    //                 }
    //             });
    //     }
    // }

    addFreeGift(giftID) {
        // console.log('addFreeGift');
        let body = JSON.stringify({
            id: giftID,
            quantity: 1,
            properties: {
                _product_type: "free gift"
            },
            sections: this.getSectionsToRender().map((section) => section.section),
            sections_url: window.location.pathname
        });

        fetch(theme.routes.cart_add_url, {...fetchConfig(), ...{body}})
            .then((response) => {
                return response.text();
            })
            .then((state) => {
                const parsedState = JSON.parse(state);
                this.updateCartList(parsedState);
            }).catch((error) => {
            console.log(error);
        });
    }

    updateFreeGiftLimitCart(cart, giftLimit) {
        // console.log('updateFreeGiftLimitCart');
        var cartQntArray = [];
        var needUpdate = false;

        for (var i = 0; i < cart.items.length; i++) {
            if (cart.items[i].properties['_product_type'] == 'free gift') {
                cartQntArray.push(0);
                needUpdate = true;
            } else {
                cartQntArray.push(cart.items[i].quantity);
            }
        }

        if (needUpdate) {
            // console.log('cartQntArray', cartQntArray);

            var formData = {
                updates: cartQntArray,
                sections: this.getSectionsToRender().map((section) => section.section),
                sections_url: window.location.pathname
            };

            fetch(window.Shopify.routes.root + 'cart/update.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            })
                .then((response) => {
                    return response.text();
                })
                .then((state) => {
                    this.addFreeGift(giftLimit);
                });
        } else {
            this.addFreeGift(giftLimit);
        }

    }

    removeFreeGiftSP(giftID) {
        let body = JSON.stringify({
            id: giftID.toString(),
            quantity: 0,
            sections: this.getSectionsToRender().map((section) => section.section),
            sections_url: window.location.pathname
        });

        fetch(theme.routes.cart_change_url, {...fetchConfig(), ...{formData}})
            .then((response) => {
                return response.text();
            })
            .then((state) => {
                const parsedState = JSON.parse(state);
                this.classList.toggle('is-empty', parsedState.item_count === 0);
                const cartFooter = document.getElementById('main-cart-footer');

                if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);

                this.getSectionsToRender().forEach((section => {
                    const elementToReplace =
                        document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

                    elementToReplace.innerHTML =
                        this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
                }));
            }).catch((error) => {
            console.log(error);
        });
    }

    checkProducts(checkOldBundle) {
        fetch('/cart.json').then(response => response.json())
            .then(cart => {
                if (checkOldBundle) {
                    var cartQntArrayOldBundle = [];
                    var oldBundleCheck = false;
                    var oldBundleUniqID;
                    for (var i = 0; i < cart.items.length; i++) {
                        // console.log(data.items[i].properties['_bundle_type'] == undefined && data.items[i].properties['_gwa_bundle_discount_fix'] == undefined && data.items[i].product_type == 'bundle');

                        if (cart.items[i].properties['_bundle_type'] == undefined
                            && cart.items[i].properties['_gwa_bundle_discount_fix'] == undefined
                            && cart.items[i].properties['_bundle_uniq_id'] != undefined
                            && cart.items[i].product_type == 'bundle'
                            && cart.items[i].properties['_bundle_gift_package_main'] == undefined) {
                            cartQntArrayOldBundle.push(0);
                            oldBundleCheck = true;
                            oldBundleUniqID = cart.items[i].properties['_bundle_uniq_id'];
                        } else if (oldBundleUniqID != undefined && cart.items[i].properties['_bundle_uniq_id'] == oldBundleUniqID) {
                            cartQntArrayOldBundle.push(0);
                        } else {
                            cartQntArrayOldBundle.push(cart.items[i].quantity);
                        }
                    }

                    if (oldBundleCheck) {
                        var formDataoldBundle = {
                            updates: cartQntArrayOldBundle,
                            sections: this.getSectionsToRender().map((section) => section.section),
                            sections_url: window.location.pathname
                        };

                        fetch(window.Shopify.routes.root + 'cart/update.js', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify(formDataoldBundle)
                        })
                            .then((response) => {
                                return response.text();
                            })
                            .then((state) => {
                                const parsedState = JSON.parse(state);
                                this.updateCartList(parsedState);
                            })
	                        .catch((error) => {
                            this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
                            // document.getElementById('cart-errors').textContent = window.cartStrings.error;
                            })
	                        .finally(() => {
		                        this.disableLoading();
	                        });
                    }
                }

                if (theme.giftsSettings.freeGiftEnable) {
                    let totalPrice = cart.total_price,
                        limitPrice1 = theme.giftsSettings.freeGiftLimit,
                        limitPrice2 = theme.giftsSettings.freeGiftLimit2,
                        limitPrice3 = theme.giftsSettings.freeGiftLimit3,
                        addFreeGiftCheck = false,
                        memberCustomer = false,
                        freeGiftMainProduct = false,
                        freeGiftProductsList = theme.giftsSettings.freeGiftProductsList.trim().split(',');

                    let giftLimit1 = Number(theme.giftsSettings.freeGiftLimitVariant != '' ? theme.giftsSettings.freeGiftLimitVariant : theme.giftsSettings.freeGiftLimitProduct),
                        giftLimit2 = Number(theme.giftsSettings.freeGiftLimitVariant2 != '' ? theme.giftsSettings.freeGiftLimitVariant2 : theme.giftsSettings.freeGiftLimitProduct2),
                        giftLimit3 = Number(theme.giftsSettings.freeGiftLimitVariant3 != '' ? theme.giftsSettings.freeGiftLimitVariant3 : theme.giftsSettings.freeGiftLimitProduct3),
                        giftSP = Number(theme.giftsSettings.freeGiftSPVariant != '' ? theme.giftsSettings.freeGiftSPVariant : theme.giftsSettings.freeGiftSPProduct);

                    if (theme.giftsSettings.freeGiftOnlyForMembers) {
                        memberCustomer = theme.memberCustomer ? true : false;
                    } else {
                        memberCustomer = true;
                    }

                    var giftInCart = false;
                    var giftLimitID = '';
                    cart.items.forEach((cartItem,i) => {
                        if (cartItem.properties['_product_type'] == 'free gift') {
                            giftInCart = true;
                            giftLimitID = cartItem.id;
                        }
                        freeGiftProductsList.forEach(item => {
                            var item_trim = item.trim();
                            if (item_trim == cartItem.handle) {
                                freeGiftMainProduct = true;
                            }
                        })
                    })

                    if (theme.giftsSettings.freeGiftType == 'cart_limit') {
                            if (memberCustomer && totalPrice >= limitPrice1 && totalPrice < limitPrice2 && giftLimit1 != null && giftLimit1 != giftLimitID) {
                                this.updateFreeGiftLimitCart(cart, giftLimit1);
                            } else if (memberCustomer && totalPrice >= limitPrice2 && totalPrice < limitPrice3 && giftLimit2 != null && giftLimit2 != giftLimitID) {
                                this.updateFreeGiftLimitCart(cart, giftLimit2);
                            } else if (memberCustomer && totalPrice >= limitPrice3 && giftLimit3 != null && giftLimit3 != giftLimitID) {
                                this.updateFreeGiftLimitCart(cart, giftLimit3);
                            } else if (giftInCart && (totalPrice < limitPrice1 || !memberCustomer)) {
                                var cartQntArray = [];

                                for (var i = 0; i < cart.items.length; i++) {
                                    if (cart.items[i].properties['_product_type'] == 'free gift') {
                                        cartQntArray.push(0);
                                    } else {
                                        cartQntArray.push(cart.items[i].quantity);
                                    }
                                }

                                var formData = {
                                    updates: cartQntArray,
                                    sections: this.getSectionsToRender().map((section) => section.section),
                                    sections_url: window.location.pathname
                                };

                                fetch(window.Shopify.routes.root + 'cart/update.js', {
                                    method: 'POST',
                                    headers: {
                                        'Content-Type': 'application/json'
                                    },
                                    body: JSON.stringify(formData)
                                })
                                    .then((response) => {
                                        return response.text();
                                    })
                                    .then((state) => {
                                        const parsedState = JSON.parse(state);
                                        this.classList.toggle('is-empty', parsedState.item_count === 0);
                                        const cartFooter = document.getElementById('main-cart-footer');

                                        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);

                                        this.getSectionsToRender().forEach((section => {
                                            const elementToReplace =
                                                document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

                                            elementToReplace.innerHTML =
                                                this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
                                        }));
                                    });

                            }


                    } else {
                        if (memberCustomer && giftSP !== undefined && freeGiftMainProduct) {
                            if (!giftInCart && cart.item_count > 0) {
                                this.addFreeGift(giftSP);

                            } else if (giftInCart && cart.item_count === 1) {
                                this.removeFreeGiftSP(giftSP);
                            }
                        } else {
                            if (giftInCart) {
                                this.removeFreeGiftSP(giftSP);
                            }
                        }
                    }
                }

                // pre order and mmq check
                var pre_order_products = 0;
                var mmq_products = 0;
                var preorderShippingDate = null;
                var preorderProduct = '';
                var cart_items = cart.items.length;
                var preOrderShippingBlock = document.querySelector('.cart-shipping-information');

                cart.items.forEach((cartItem,i) => {
                    if (cartItem.properties['_pre_order_shipping_date'] !== undefined) {
                        pre_order_products ++;
                        cart_items --;

                        var has_companion = false;
                        if (cartItem.properties['_uniqId'] !== undefined) {
                            cart.items.forEach((potential_companion,i) => {
                                if (potential_companion.properties['_uniqId'] === cartItem.properties['_uniqId'] && potential_companion !== cartItem) {
                                    has_companion = true;
                                    cart_items --;
                                }
                            });
                        }

                        let itemDate = new Date(cartItem.properties['_pre_order_shipping_date']);
                        if (!preorderShippingDate || itemDate > preorderShippingDate) {
                            preorderShippingDate = itemDate;
                            preorderProduct = cartItem.title;
                        }
                    }

                    if (cartItem.properties['_mmqProduct'] !== undefined) {
                        mmq_products ++;
                    }
                });

                if (preOrderShippingBlock) {
                    if (pre_order_products > 0) {
                        preOrderShippingBlock.innerHTML = cart_items > 0 ? theme.strings.preOrderTextHtml : theme.strings.preOrderOnlyTextHtml;

                        let productSpan = preOrderShippingBlock.querySelector('span.product');
                        let dateSpan = preOrderShippingBlock.querySelector('span.date');

                        if (mmq_products > 0) {
                            const mmq_date = new Date();
                            mmq_date.setDate(mmq_date.getDate() + 56);

                            if (preorderShippingDate > mmq_date) {
                                if (productSpan) productSpan.textContent = preorderProduct;
                                if (dateSpan) dateSpan.textContent = this.formatDate(preorderShippingDate);
                            } else {
                                preOrderShippingBlock.textContent = theme.strings.mimeeqText;
                            }
                        } else {
                            if (productSpan) productSpan.textContent = preorderProduct;
                            if (dateSpan) dateSpan.textContent = this.formatDate(preorderShippingDate);
                        }
                    } else if (mmq_products > 0) {
                        preOrderShippingBlock.textContent = mmq_products === cart.items.length ? theme.strings.mimeeqOnlyText : theme.strings.mimeeqText;
                    } else {
                        preOrderShippingBlock.remove();
                    }
                }
            });
    }

    async checkEmbossingAndGiftPackaging() {
        const response = await fetch('/cart.json');
        const cart = await response.json();

        let embossing_array = [];
        let gift_packaging_array = [];
        let items_to_remove = [];

        cart.items.forEach(item => {
            if (item.product_type == "Embossing") {
                let embossingUniqId = item.properties['_uniqId'];
                if (!embossing_array.includes(embossingUniqId)) {
                    embossing_array.push(embossingUniqId);
                }
            } else if (item.product_type == "Gift packaging") {
                let giftPackagingUniqId = item.properties['_uniqId'];
                if (!gift_packaging_array.includes(giftPackagingUniqId)) {
                    gift_packaging_array.push(giftPackagingUniqId);
                }
            }
        });

        const checkAndRemoveItems = async (array, productType) => {
	        const cartContainer = this.closest('cart-items') || this.closest('cart-drawer-items');
            for (const uniqId of array) {
                let found = false;

                cart.items.forEach(item => {
                    if (item.product_type !== 'Embossing' && item.product_type !== 'Gift packaging' && item.properties['_uniqId'] === uniqId) {
                        found = true;
                    }
                });

                if (!found) {
                    for (let i = 0; i < cart.items.length; i++) {
                        let item = cart.items[i];
                        if (item.product_type === productType && item.properties['_uniqId'] === uniqId) {
                            items_to_remove.push(item.id);
                            // Дожидаемся удаления продукта
                            await cartContainer.updateQuantity(i + 1, 0, 'remove');
                        }
                    }
                }
            }
        };

        if (embossing_array.length > 0) await checkAndRemoveItems(embossing_array, 'Embossing');
        if (gift_packaging_array.length > 0) await checkAndRemoveItems(gift_packaging_array, 'Gift packaging');
    }


    // checkOldBundle() {
    //     fetch('/cart.json').then(response => response.json())
    //         .then(data => {
    //             var cartQntArray = [];
    //             var oldBundleCheck = false;
    //             var oldBundleUniqID;
    //             for (var i = 0; i < data.items.length; i++) {
    //                 // console.log(data.items[i].properties['_bundle_type'] == undefined && data.items[i].properties['_gwa_bundle_discount_fix'] == undefined && data.items[i].product_type == 'bundle');
    //
    //                 if (data.items[i].properties['_bundle_type'] == undefined
    //                     && data.items[i].properties['_gwa_bundle_discount_fix'] == undefined
    //                     && data.items[i].properties['_bundle_uniq_id'] != undefined
    //                     && data.items[i].product_type == 'bundle') {
    //                     cartQntArray.push(0);
    //                     oldBundleCheck = true;
    //                     oldBundleUniqID = data.items[i].properties['_bundle_uniq_id'];
    //                 } else if (oldBundleUniqID != undefined && data.items[i].properties['_bundle_uniq_id'] == oldBundleUniqID) {
    //                     cartQntArray.push(0);
    //                 } else {
    //                     cartQntArray.push(data.items[i].quantity);
    //                 }
    //             }
    //
    //             var formData = {
    //                 updates: cartQntArray,
    //                 sections: this.getSectionsToRender().map((section) => section.section),
    //                 sections_url: window.location.pathname
    //             };
    //
    //             // console.log(formData);
    //
    //             if (oldBundleCheck) {
    //                 fetch(window.Shopify.routes.root + 'cart/update.js', {
    //                     method: 'POST',
    //                     headers: {
    //                         'Content-Type': 'application/json'
    //                     },
    //                     body: JSON.stringify(formData)
    //                 })
    //                     .then((response) => {
    //                         return response.text();
    //                     })
    //                     .then((state) => {
    //                         const parsedState = JSON.parse(state);
    //                         this.updateCartList(parsedState);
    //
    //                         this.checkFreeGift();
    //                     }).catch((error) => {
    //                     this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
    //                     // document.getElementById('cart-errors').textContent = window.cartStrings.error;
    //                     this.disableLoading();
    //                 });
    //             } else {
    //                 this.checkFreeGift();
    //             }
    //         });
    // }

    formatDate(date) {
        const day = date.getDate();
        const year = date.getFullYear();

        const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        const monthName = months[date.getMonth()];

        const formattedDate = `${day} ${monthName} ${year}`;

        return formattedDate
    }
}

customElements.define('cart-items', CartItems);

class QuantityInput extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector('input');
        this.changeEvent = new Event('change', { bubbles: true })

        this.querySelectorAll('button').forEach(
            (button) => button.addEventListener('click', this.onButtonClick.bind(this))
        );
    }

    onButtonClick(event) {
        event.preventDefault();
        const previousValue = this.input.value;

        event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
        if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    }
}

customElements.define('quantity-input', QuantityInput);
